import React from 'react'
import PropTypes from 'prop-types'

import GalleryWithLightbox from 'Pods/Shared/GalleryWithLightbox'

function JobAttachmentsImages({ imagesUrls, attachments, onImageClick }) {
  return (
    <div className="row jobs-attachments__images u-mb10">
      {attachments.map((attachment, index) => (
        <div className="col-4" key={attachment[0].title}>
          <div className="image-wrapper">
            <img
              src={attachment[0].url}
              alt={attachment[0].title}
              onClick={(e) => onImageClick(index, e)}
              className="attachment-image"
            />
          </div>
        </div>
      ))}
    </div>
  )
}

JobAttachmentsImages.propTypes = {
  imagesUrls: PropTypes.array.isRequired,
  attachments: PropTypes.arrayOf(
    PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }))
  ).isRequired,
  onImageClick: PropTypes.func.isRequired,
}

export default GalleryWithLightbox(JobAttachmentsImages)
